import React, { useContext, useEffect, useState } from "react";
import FloatingInput from "../../atoms/floatingInput/floatingInput";
import FloatingSelect from "../../atoms/floatingSelect/floatingSelect";
import Button from "../../atoms/dropdown/dropdown";
import GenericModal from "../../GenericModal/index";
import { useHistory } from "react-router";
import { makeAPICall } from "src/services/apiService";
import axios from "axios";
import BackArrow from "src/atoms/backArrow/backArrow";
import { Link } from "react-router-dom"; 
import exchangeIcon from "../../assets/images/swap.svg"
import PlusIcon from "../../assets/images/plusIcon.svg"
import warnIcon from "../../assets/images/warn-red.svg";
import "./exchange.scss"
import { getCookie, getPaymentAmout } from "../../utils/utils";
import DeleteIcon from "../../assets/images/deleteOrderIcon.svg"
import CheckTick from "../../assets/images/checked-tick.svg"
import Loader from "../../atoms/Loader"
import { Tick } from "../../assets/images/assetsAll";

function ScooterExchangeEdit() {
  const history = useHistory();
  const loan = ["Completed", "Pending"];
  const condtion = ["Running", "Not working"];
  const ownerships = [1, 2, 3, 4, 5];
  const [range, setRange] = useState([
    {
      "id": 1,
      "from_distance": 0,
      "to_distance": 10000,
    },
    {
      "id": 2,
      "from_distance": 10001,
      "to_distance": 20000,
    },
    {
      "id": 3,
      "from_distance": 20001,
      "to_distance": 30000,
    },
    {
      "id": 4,
      "from_distance": 30001,
      "to_distance": 40000,
    },
    {
      "id": 18,
      "from_distance": 40001,
      "to_distance": 60000,
    },
    {
      "id": 19,
      "from_distance": 60000,
      "to_distance": 300000,
    }
  ]);
  const [continueBtnDisabled, setContinueBtnDisabled] = useState(true);
  const [responseArray, setResponseArray] = useState([]);
  const [previousBikeData, setPreviousBikeData] = useState({});
  const [bikePayload, setBikePayload] = useState({});

  //exchange patner states
  const [exchangePatner, setExchangePatner] = useState({})
  const [showExchangePatner,setShowExchangePatner]=useState(false)
  const [exchangeSelected,setExchangeSelected]=useState(false)
  const [exchangePatnerData, setExchangePatnerData] = useState([])
  const [previousExchangePartner,setPreviousExchangePartner]=useState("")
  const [filterPartnerArray,setFilterPartnerArray]=useState([])
  const [searchPartner,setSearchPartner]=useState("")
  const [customVendorName, setCustomVendorName] = useState("")
  const [showCustomVendorInput, setShowCustomVendorInput] = useState(false)

  //brand states
  const [brandName, setBrandName] = useState("");
  const [showBrand, setShowBrand] = useState(false);
  const [brandSeleceted, setBrandSelected] = useState(false);
  const [customBrandName, setCustomBrandName] = useState("")
  const [showCustomBrandInput, setShowCustomBrandInput] = useState(false)

  //model states
  const [modelName, setModelName] = useState("");
  const [showModel, setShowModel] = useState(false);
  const [modelSeleceted, setModelSelected] = useState(false);
  const [customModelName, setCustomModelName] = useState("")
  const [showCustomModelInput, setShowCustomModelInput] = useState(false)
  
  //model Year states
  const [modelYear, setModelYear] = useState("");
  const [showModelYear, setShowModelYear] = useState(false);
  const [modelYearSeleceted, setModelYearSelected] = useState(false);

  //loan states
  const [bikeLoan, setBikeLoan] = useState("");
  const [showBikeLoan, setShowBikeLoan] = useState(false);
  const [bikeLoanSeleceted, setBikeLoanSelected] = useState(false);

  //bike condition states
  const [bikeCondtion, setBikeCondtion] = useState("");
  const [showBikeCondition, setShowBikeCondition] = useState(false);
  const [bikeConditionSeleceted, setBikeConditionSelected] = useState(false);
  
  //ec region state
  const [ecRegion, setEcRegion] = useState("")
  const [showEcRegion, setShowEcRegion] = useState(false);
  const [ecRegionSelected, setEcRegionSelected] = useState(false);
  
  //ec name state
  const [ecName, setEcName] = useState("")
  const [showEcName, setShowEcName] = useState(false);
  const [ecNameSelected, setEcNameSelected] = useState(false);
  
  //owner name state
  const [ownersName, setOwnersName] = useState("");

  //customer name state 
  const [customerName, setCustomerName] = useState("");


  // Transaction Id state
  // const [transactionId, setTransactionId] = useState("")

  //Biker reg num state
  const [regNumber, setRegNumber] = useState("");

  //Ownership states
  const [ownership, setOwnership] = useState("");
  const [showOwnership, setShowOwnership] = useState(false);
  const [ownershipSeleceted, setOwnershipSelected] = useState(false);

  //kilometer states
  const [kilometer, setKilometer] = useState({
    from_distance: null,
    to_distance: null,
  });
  const [showBikeRange, setShowBikeRange] = useState(false);
  const [bikeRangeSelected, setBikeRangeSelected] = useState(false);

  const [toastMsg, setToastMsg] = useState("")
  const [showToggle, setShowToggle] = useState(false)

  const [dataOfSelectedBrand, setDataOfSelectedBrand] = useState({});
  const [brands, setBrands] = useState([])
  const [ecRegions, setEcRegions] = useState([])
  const [ecNames, setEcNames] = useState([])
  const [models, setModels] = useState([])
  const [variants, setVariants] = useState([])
  const [colors, setColors] = useState([])
  const [distanceRange, setDistanceRange] = useState([])
  const [modelRef, setModelRef] = useState("")
  const [year, setyear] = useState([]);
  const [callTime, setCallTime] = useState(false);
  const ownershipMap = { 1: "First", 2: "Second", 3: "Third", 4: "Fourth", 5: "Fifth" };
  const [showVerifyPopup, setShowVerifyPopup] = useState(false)
  const vehConditionLimit = 3
  const scooterRegImgLimit = 5
  const registration_certificate = 2
  const form_length = 3
  const kyc_doc = 2
  const optional_length = 3
  const [vehicleUploadStatus, setVehicleUploadStatus] = useState([false, false, false])
  const [optionalUploadStatus,setOptionalUploadStatus] = useState([false,false,false])
  const [vehConditionList, setVehConditionList] = useState({})
  const [scooterRegList, setScooterRegList] = useState({})
  const [formImageList,setFormImageList]=useState({})
  const [kycDocList,setDocList]=useState({})
  const [optionalList,setOptionalList]=useState({})
  const [exchangeValue, setExchangeValue] = useState("")
  const [orderUserData, setOrderUserData] = useState({})
  const [registrationNo, setRegistrationNo] = useState("")
  const [showToast, setShowToast] = useState('none');
  const [toastMessage, setToastMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false)
  const [bcCreate, setBcCreate] = useState(false)
  const [vendorKey, setVendorKey] = useState("")
  const [vendorKeyCF, setVendorKeyCF] = useState("")  

  //variant states
  const [variantName, setVariantName] = useState("")
  const [showVariant, setShowVariant] = useState(false)
  const [variantSeleceted, setVariantSelected] = useState(false)
  const [customVariantName, setCustomVariantName] = useState("")

  //color states
  const [colorName, setColorName] = useState("")
  const [showColor, setShowColor] = useState(false)
  const [colorSeleceted, setColorSelected] = useState(false)
  const [customColorName, setCustomColorName] = useState("")
  const [showCustomColorInput, setShowCustomColorInput] = useState(false)
  const [pincode, setPincode] = useState("")
  const [colorGroups, setColorGroups] = useState({})
  const [colorGroupSelected, setColorGroupSelected] = useState("")

  const [searchedBrand, setSearchedBrand] = useState("")
  const [searchedModel, setSearchedModel] = useState("")
  const [searchedVariant, setSearchedVariant] = useState("")
  const [searchedEcRegion, setSearchedEcRegion] = useState("")
  const [searchedEcName, setSearchedEcName] = useState("")

  const [showSplitErrorPopup, setShowSplitErrorPopup] = useState(false);
  const [splitPayErrorHeader, setSplitPayErrorHeader] = useState("");
  const [splitPayErrorSubtext, setSplitPayErrorSubtext] = useState("");
  const [checkedStatus, setCheckedStatus]=useState(false)
  const [businessId, setBusinessId] = useState("")
  
  useEffect(() => {
    getAllBrands()
    setFilterPartnerArray([...exchangePatnerData])
  }, [exchangePatnerData])

  useEffect(() => {
      if (previousBikeData) {
          getDataAccToPrevBikeData()
      } else {
        getAllBrands()
      }
  }, [previousBikeData])

  useEffect(() => {
    if(previousBikeData && colorGroups && colors?.length && colorName) {
        let preColorRef = colors.find(item => item.color == previousBikeData?.color)
        if(preColorRef) {
            getAllYears(preColorRef)
        }
    }
  }, [colorGroups, colors])

  const retrieveDocs = (type, ind) => {
    let config = {
      method: "get",
      url: `api/exchange/retrieve-docs`,
      headers: {
        oem_auth_token: getCookie("oem_auth_token")
      },
      params: {
        ...history.location.state,
        order_id: history.location.state.order_id,
        type: type,
      },
    };

    makeAPICall(config)
      .then((resp) => {
        if(type == "SCOOTER_REGISTRATION") {
          resp.data.data.files.map((item, index) => {
            scooterRegList[`reg-preview-img-registration${index}`] = item.file;
            document.getElementById('reg-preview-img-registration' + index).src = item.file;
            document.getElementById('reg-preview-img-registration' + index).style.width = "100%"
            document.getElementById('reg-preview-img-registration' + index).style.left = "0"
            setScooterRegList({
              ...scooterRegList
            })
          })
        } else if (type == "EXCHANGE_FORM_29") {
          resp.data.data.files.map((item, index) => {
            formImageList[`reg-preview-img-form${index}`] = item.file;
            document.getElementById('reg-preview-img-form' + 0).src = item.file;
            document.getElementById('reg-preview-img-form' + 0).style.width = "100%"
            document.getElementById('reg-preview-img-form' + 0).style.left = "0"
            setFormImageList({
              ...formImageList
            })
          })
        } else if (type == "EXCHANGE_FORM_30") {
          resp.data.data.files.map((item, index) => {
            formImageList[`reg-preview-img-form${index+1}`] = item.file;
            document.getElementById('reg-preview-img-form' + (index+1)).src = item.file;
            document.getElementById('reg-preview-img-form' + (index+1)).style.width = "100%"
            document.getElementById('reg-preview-img-form' + (index+1)).style.left = "0"
            setFormImageList({
              ...formImageList
            })
          })
        } 
        else if (type == "EXCHANGE_AUTH_LETTER") {
          resp.data.data.files.map((item, index) => {
            kycDocList[`reg-preview-img-kyc0`] = item.file;
            document.getElementById('reg-preview-img-kyc' + 0).src = item.file;
            document.getElementById('reg-preview-img-kyc' + 0).style.width = "100%"
            document.getElementById('reg-preview-img-kyc' + 0).style.left = "0"
            setDocList({
              ...kycDocList
            })
          })
        } else if (type == "EXCHANGE_KYC_DOC") {
          resp.data.data.files.map((item, index) => {
            kycDocList[`reg-preview-img-kyc1`] = item.file;
            document.getElementById('reg-preview-img-kyc' + 1).src = item.file;
            document.getElementById('reg-preview-img-kyc' + 1).style.width = "100%"
            document.getElementById('reg-preview-img-kyc' + 1).style.left = "0"
            setDocList({
              ...kycDocList
            })
          })
        } else if (type.includes("EXCHANGE_OPTIONAL_DOC")) {
          resp.data.data.files.map((item, index) => {
            let i = item.type.split("EXCHANGE_OPTIONAL_DOC_")[1] - 1;
            optionalList[`reg-preview-img-optional${i}`] = item.file;
            document.getElementById('reg-preview-img-optional' + i).src = item.file;
            document.getElementById('reg-preview-img-optional' + i).style.width = "100%"
            document.getElementById('reg-preview-img-optional' + i).style.left = "0"
            optionalUploadStatus[i] = true
            setOptionalUploadStatus([...optionalUploadStatus])
            setOptionalList({
              ...optionalList
            })
          })
        } 
        else {
          resp.data.data.files.map((item, index) => {
            let i = item.type.split("VEHICLE_CONDITION_")[1] - 1;
            // scooterRegList[`reg-preview-img-vehicle-condition${i}`] = item.file;
            vehConditionList[`reg-preview-img-vehicle-condition${i}`] = item.file
            document.getElementById('reg-preview-img-vehicle-condition' + i).src = item.file;
            document.getElementById('reg-preview-img-vehicle-condition' + i).style.width = "100%"
            document.getElementById('reg-preview-img-vehicle-condition' + i).style.left = "0"
            vehicleUploadStatus[i] = true
            setVehicleUploadStatus([...vehicleUploadStatus])
            setVehConditionList({
              ...vehConditionList
            })
          })
        }
      })
      .catch((err) => {
        console.log("failed");
        // toggleToaster(`Somethin went wrong`)
      });

  }
  const getDataAccToPrevBikeData = async () => {
    if (
      previousBikeData?.brand &&
      previousBikeData?.model &&
      previousBikeData?.variant &&
      previousBikeData?.color
    ) {
      getAllBrands().then((res) => {
          console.log(res, "getAllBrands, resss")
        getAllModels(previousBikeData?.brand).then((ress) => {
          console.log(ress, "getAllModels, resss")
          getAllVariants(previousBikeData?.model, {brand: previousBikeData?.brand}).then((resss) => {
              console.log(resss, "getAllVariants, resss")
            getAllColors(previousBikeData?.variant, {brand: previousBikeData?.brand, model: previousBikeData?.model});
          });
        });
      });
      for (let i = 1; i <= vehConditionLimit; i++) {
        retrieveDocs(`VEHICLE_CONDITION_${i}`)
      }
      retrieveDocs("SCOOTER_REGISTRATION")
      retrieveDocs("EXCHANGE_FORM_29")
      retrieveDocs("EXCHANGE_FORM_30")
      retrieveDocs("EXCHANGE_AUTH_LETTER")
      retrieveDocs("EXCHANGE_KYC_DOC")
      retrieveDocs(`EXCHANGE_OPTIONAL_DOC_1`)
      retrieveDocs(`EXCHANGE_OPTIONAL_DOC_2`)
      retrieveDocs(`EXCHANGE_OPTIONAL_DOC_3`)
      
    }
  };

  useEffect(() => {
    getAllEcRegions()
    getExchangeStaticData()
    setOrderUserData(history.location.state)
    // getAllBrands();
      // let config = {
      //   method: "get",
      //   url: `api/exchange/getModelData`,
      //   headers: {
      //     'x-flow': "BC_CREATE"
      //   }
      // };
      // makeAPICall(config)
      //   .then((resp) => {
      //     if (resp?.data) {
      //       setResponseArray(resp.data.data.exchange_specifications);
      //       setRange(resp.data.data.distance_ranges);
      //     }
      //   })
      //   .catch((err) => {
      //     console.log(err);
      //     toggleToaster(`Somethin went wrong`)
      //   });


    
      if(history.location.state.action == "VIEW_EDIT" || history.location.state.action == "EXCHANGE_SOFT_REJECTED") {
        let config = {
          method: "get",
          url: `api/exchange/getExchangeOrderDetail`,
          params: {
            ...history.location.state,
          },
        };
  
        makeAPICall(config)
          .then((resp) => {
            if (resp && resp.data.status === "SUCCESSFUL") {
              setPreviousBikeData(resp.data.data);
            }
            if (resp.data.data?.brand) {
              setBcCreate(true)
            } else {
              setBcCreate(false)
            }
          })
          .catch((err) => {
            console.log("failed");
            toggleToaster(`Somethin went wrong`)
          });
      }
    
          let payload = {
            method: "get",
            url:'api/exchange/exchangePatnerData'
          }
          makeAPICall(payload)
          .then((response) => {
            console.log("this is echange patner response", response);
            setExchangePatnerData(response?.data?.data)
          })
          .catch((err) => {
            console.log("error in getting patner data", err);
            toggleToaster(`Somethin went wrong`)
        })


  }, []);

  useEffect(() => {
    if (previousBikeData) {
      setCheckedStatus(previousBikeData?.is_customer_owner)
      setBusinessId(previousBikeData?.business_unit_id)
      setPreviousExchangePartner(previousBikeData?.other_attributes?.partner_id)
      // setExchangePatner(previousBikeData?.other_attributes?.id) //verify once
      setExchangeSelected(previousBikeData?.other_attributes?.partner_id ? true : false)//verify once
      setBrandName(previousBikeData?.brand);
      setBrandSelected(previousBikeData?.brand ? true : false);
      setModelName(previousBikeData?.model);
      setModelSelected(previousBikeData?.model ? true : false);
      setModelYear(previousBikeData?.year);
      setModelYearSelected(previousBikeData?.year ? true : false);
      setBikeLoan(previousBikeData?.other_attributes?.loan_status);
      setBikeLoanSelected(
        previousBikeData?.other_attributes?.loan_status ? true : false
      );
      setBikeCondtion(previousBikeData?.other_attributes?.running_condition);
      setBikeConditionSelected(
        previousBikeData?.other_attributes?.running_condition ? true : false
      );
      setEcRegion(previousBikeData?.ec_region)
      setEcRegionSelected(previousBikeData?.ec_region ? true : false)
      setEcNameSelected(previousBikeData?.ec_name ? true : false)
      setEcName(previousBikeData?.ec_name)
      setOwnersName(previousBikeData?.owner_name);
      setCustomerName(previousBikeData?.customer_name)
      setKilometer({
        from_distance: previousBikeData?.from_distance,
        to_distance: previousBikeData?.to_distance,
      });
      setBikeRangeSelected(
        previousBikeData?.from_distance || previousBikeData?.to_distance
          ? true
          : false
      );
      setRegNumber(previousBikeData?.other_attributes?.registration_number);
      setOwnership(previousBikeData?.other_attributes?.ownership);
      setOwnershipSelected(
        previousBikeData?.other_attributes?.ownership ? true : false
      );

      let currencyValue = previousBikeData?.exchange_value + ''
      currencyValue = currencyValue?.replace(/[^0-9 ]/g, "");
      currencyValue = currencyValue?.replace(/(\d)(?=(\d\d)+\d$)/g, "$1,");
      currencyValue = "₹" + currencyValue;
      setExchangeValue(currencyValue)
      setRegistrationNo(previousBikeData?.other_attributes?.registration_number)
      // setTransactionId(previousBikeData?.transaction_id || "")

      setVariantName(previousBikeData?.variant)
      setVariantSelected(previousBikeData?.variant ? true : false)
      if(previousBikeData?.color && previousBikeData.color in colorGroups) {
        setColorName(colorGroups[previousBikeData?.color]?.join("/"))
      } else {
        setColorName(previousBikeData?.color)
      }
      setColorSelected(previousBikeData?.color ? true : false)
      setPincode(previousBikeData?.pin_code)
      setVendorKey(previousBikeData?.other_attributes?.vendor_key)
      setVendorKeyCF(previousBikeData?.other_attributes?.vendor_key_customer_flow)
    }
    if (previousBikeData) {
      setDataOfSelectedBrand(
        brands.find((a) => a.brand == previousBikeData?.brand)
      );
      // setyear(
      //   responseArray
      //     .find((a) => a.brand == previousBikeData?.brand)
      //     ?.models.find((mod) => mod.model == previousBikeData?.model)?.year
      // );
    }
    checkLogicForBtnDisabled();
  }, [previousBikeData, responseArray, colorGroups]);

  useEffect(() => {
    checkLogicForBtnDisabled();
    if (!continueBtnDisabled) { 
      let exchange_value = exchangeValue + ''
      exchange_value = Number(exchange_value?.replace(/[^0-9 ]/g, ""));
      let payload = {
        order_id: orderUserData?.order_id || "",
        brand: brandName,
        model: modelName,
        year: Number(modelYear),
        owner_name: ownersName,
        ec_region : ecRegion,
        ec_name : ecName,
        customer_name:customerName,
        from_distance: kilometer.from_distance,
        to_distance: kilometer.to_distance,
        other_attributes: {
          partner_id: exchangePatner?.id,
          running_condition: bikeCondtion,
          loan_status: bikeLoan,
          registration_number: regNumber,
          ownership: ownership,
          registration_number: registrationNo
        },
        is_home_pickup: previousBikeData?.is_home_pickup || true,
        exchange_value,
        pin_code: Number(pincode),
        variant: variantName,
        color: colorGroupSelected || colorName,
        // transaction_id: transactionId,
        is_customer_owner: checkedStatus,
        business_unit_id: businessId,
        is_final_submit:showVerifyPopup
      };
      setBikePayload(payload);
    }
  }, [
    exchangePatner,
    businessId,
    brandName,
    modelName,
    modelYear,
    bikeLoan,
    bikeCondtion,
    ownersName,
    ecName,
    ecRegion,
    customerName,
    ownership,
    regNumber,
    kilometer.from_distance,
    kilometer.to_distance,
    continueBtnDisabled,
    exchangeValue,
    vehConditionList,
    scooterRegList,
    formImageList,
    registrationNo,
    variantName,
    colorName,
    pincode,
    // transactionId,
    checkedStatus,
    showVerifyPopup
  ]);

  //   useEffect(() => {
  //     checkLogicForBtnDisabled();
  //   }, [exchangeDiscountQotation]);



  const getExchangeStaticData = async () => {
    const response = await (await fetch("/api/exchange/getExchangeStaticData")).json();
    setColorGroups(response.color_groups)
    setSplitPayErrorHeader(response.bc_split_err_msg?.header)
    setSplitPayErrorSubtext(response.bc_split_err_msg?.subtext)
  }

  const checkLogicForBtnDisabled = () => {
    const actualBrandName = showCustomBrandInput ? customBrandName : brandName;
    const actualModelName = showCustomModelInput ? customModelName : modelName;
    const actualVariantName = showCustomModelInput ? customVariantName : variantName;
    const actualColorName = showCustomColorInput ? customColorName : colorName;
    const actualVendorId = showCustomVendorInput ? 1 : exchangePatner?.id;
    const actualVendorName = showCustomVendorInput ? customVendorName : exchangePatner?.partner_name;
    if (
      checkedStatus &&
      actualVendorId && 
      actualBrandName && 
      actualModelName && 
      // exchangePatner?.id &&
      // brandName &&
      // modelName &&
      //modelYear &&
      bikeLoan &&
      bikeCondtion &&
      ownersName?.trim() &&
      ecName?.trim() &&
      ecRegion?.trim() &&
      customerName?.trim() &&
      kilometer &&
      bikeCondtion !== "Not working" &&
      bikeLoan !== "Pending" &&
      exchangeValue && 
      registrationNo && 
      ownership &&
      (actualColorName || customColorName) &&
      // Object.keys(vehConditionList)?.length >= 2 && 
      Object.keys(scooterRegList)?.length >= 2 && 
      Object.keys(vehConditionList)?.length >= 2 && 
      Object.keys(formImageList)?.length >= 3 &&
      // transactionId.length &&
      // (orderUserData?.action == "CREATE_NEW" ? Object.keys(vehConditionList)?.length >= 2 : true) && 
      // (orderUserData?.action == "CREATE_NEW" ? Object.keys(scooterRegList)?.length >= 1 : true) &&
      (
        // exchangePatner != previousBikeData?.other_attributes?.id || 
      // brandName != previousBikeData.brand ||
      // modelName != previousBikeData.model ||
      actualBrandName != previousBikeData?.brand ||
      actualModelName != previousBikeData?.model ||
      bikeLoan != previousBikeData?.other_attributes?.loan_status ||
      modelYear != previousBikeData.year ||
      bikeCondtion != previousBikeData?.other_attributes?.running_condition ||
        ownersName != previousBikeData.owner_name ||
        ecName != previousBikeData.ec_name ||
        ecRegion != previousBikeData.ec_region ||
        customerName != previousBikeData.customer_name ||
      exchangeValue != previousBikeData.exchange_value ||
      registrationNo != previousBikeData?.other_attributes?.registration_number ||
      ownership != previousBikeData?.other_attributes?.ownership ||
      kilometer?.from_distance != previousBikeData?.from_distance || 
      kilometer?.to_distance != previousBikeData?.to_distance || 
      actualVariantName != previousBikeData?.variant  || 
      actualColorName != colorGroups[previousBikeData.color]?.join("/")  || 
      pincode != previousBikeData?.pin_code ||
      actualVendorName != previousBikeData?.other_attributes?.partner_name
      )
      //   exchangeDiscountQotation.quotation_value > 0
    ) {
      setContinueBtnDisabled(false);
    } else {
      setContinueBtnDisabled(true);
    }
  };

  //   const callGetOffers = () => {
  //     if (
  //       !!(
  //         brandName &&
  //         modelName &&
  //         modelYear &&
  //         ownership &&
  //         (kilometer.from_distance || kilometer.to_distance)
  //       )
  //     ) {
  //       getExchangeOfferPrice({
  //         brand: brandName,
  //         model: modelName,
  //         year: modelYear,
  //         from_distance: kilometer.from_distance,
  //         to_distance: kilometer.to_distance,
  //         ownership: ownership,
  //       });
  //     }
  //   };

  //   useEffect(() => {
  //     callGetOffers();
  //   }, [callTime]);

  async function getAllEcRegions() {
    let config1 = {
      method: "get",
      url: `api/exchange/get-all-regions`,
    };
    await makeAPICall(config1)
      .then((resp) => {
        console.log(resp?.data?.data, "respssaa")
        setEcRegions(resp?.data?.data)
      })
      .catch((err) => {
        console.log(err);
        toggleToaster(`Somethin went wrong`)
      });
  }

  async function getAllEcNames(id) {
    let config1 = {
      method: "get",
      url: `api/exchange/get-all-ec-names?id=${id}`,
    };
    await makeAPICall(config1)
      .then((resp) => {
        console.log(resp?.data?.data, "respssaa")
        setEcNames(resp?.data?.data)
      })
      .catch((err) => {
        console.log(err);
        toggleToaster(`Somethin went wrong`)
      });
  }
  async function getAllBrands() {
    let config1 = {
      method: "get",
      url: `api/exchange/get-all-brands`,
      headers: {
        'x-flow': orderUserData?.action == "EXCHANGE_SOFT_REJECTED" ? "CUSTOMER_CREATE_BC_EDIT" : "BC_CREATE",
        "x-vendor": vendorKey || previousBikeData?.other_attributes?.vendor_key  || "",
        "x-tenant": orderUserData?.action == "EXCHANGE_SOFT_REJECTED" ? ((vendorKey || previousBikeData?.other_attributes?.vendor_key)  ? "OLD" : "NEW") : ""
      }
    };
    await makeAPICall(config1)
      .then((resp) => {
        console.log(resp.data, "resp")
        if (resp?.data) {
          setBrands(resp.data.data.exchange_info_list);
        }
        return
      })
      .catch((err) => {
        console.log(err);
        toggleToaster(`Somethin went wrong`)
      });
  }

  async function getAllModels(el) {
    let config1 = {
      method: "get",
      url: `api/exchange/get-brand-models`,
      headers: {
        'x-flow': orderUserData?.action == "EXCHANGE_SOFT_REJECTED" ? "CUSTOMER_CREATE_BC_EDIT" :  "BC_CREATE",
        "x-vendor": vendorKey || previousBikeData?.other_attributes?.vendor_key || "",
        "x-tenant": orderUserData?.action == "EXCHANGE_SOFT_REJECTED" ? ((vendorKey || previousBikeData?.other_attributes?.vendor_key) ? "OLD" : "NEW") : ""
      },
      params: {
        brandName: el,
      }
    };
    await makeAPICall(config1)
      .then((resp) => {
        console.log(resp.data, "resp")
        if (resp?.data) {
          setModels(resp.data.data.exchange_info_list);
        }
        return
      })
      .catch((err) => {
        console.log(err);
        toggleToaster(`Somethin went wrong`)
      });
  }

  async function getAllVariants(el, bod) {
    let config1 = {
      method: "get",
      url: `api/exchange/get-model-variants`,
      headers: {
        'x-flow': orderUserData?.action == "EXCHANGE_SOFT_REJECTED" ? "CUSTOMER_CREATE_BC_EDIT" :  "BC_CREATE",
        "x-vendor": vendorKey || previousBikeData?.other_attributes?.vendor_key || "",
        "x-tenant": orderUserData?.action == "EXCHANGE_SOFT_REJECTED" ? ((vendorKey || previousBikeData?.other_attributes?.vendor_key)  ? "OLD" : "NEW") : ""
      },
      params: {
        brandName: brandName || bod.brand,
        modelName: el
      }
    };
    await makeAPICall(config1)
      .then((resp) => {
        console.log(resp.data, "resp")
        if (resp?.data) {
          setVariants(resp.data.data.exchange_info_list);
        }
        return
      })
      .catch((err) => {
        console.log(err);
        toggleToaster(`Somethin went wrong`)
      });
  }

  async function getAllColors(el, bod) {
    let config1 = {
      method: "get",
      url: `api/exchange/get-variant-colors`,
      headers: {
        'x-flow': orderUserData?.action == "EXCHANGE_SOFT_REJECTED" ? "CUSTOMER_CREATE_BC_EDIT" :  "BC_CREATE",
        "x-vendor": vendorKey || previousBikeData?.other_attributes?.vendor_key  || "",
        "x-tenant": orderUserData?.action == "EXCHANGE_SOFT_REJECTED" ? ((vendorKey || previousBikeData?.other_attributes?.vendor_key)  ? "OLD" : "NEW") : ""
      },
      params: {
        brandName: brandName || bod.brand,
        modelName: modelName || bod.model,
        variant: el,
      }
    };
    await makeAPICall(config1)
      .then((resp) => {
        console.log(resp.data, "resp")
        if (resp?.data) {
          setColors(resp?.data?.data?.exchange_info_list);
        }
        return
      })
      .catch((err) => {
        console.log(err);
        toggleToaster(`Somethin went wrong`)
      });
  }

  async function getAllYears(el) {
    let config1 = {
      method: "get",
      url: `api/exchange/get-color-years`,
      headers: {
        'x-flow': orderUserData?.action == "EXCHANGE_SOFT_REJECTED" ? "CUSTOMER_CREATE_BC_EDIT" :  "BC_CREATE",
        "x-vendor": vendorKey || previousBikeData?.other_attributes?.vendor_key  || "",
        "x-tenant": orderUserData?.action == "EXCHANGE_SOFT_REJECTED" ? ((vendorKey || previousBikeData?.other_attributes?.vendor_key) ? "OLD" : "NEW") : ""
      },
      params: {
        brandName: brandName || previousBikeData.brand,
        modelName: modelName || previousBikeData.model,
        variant: variantName || previousBikeData.variant,
        color: el?.color || previousBikeData.color,
        model_ref: el?.model_ref || modelRef
      }
    };
    await makeAPICall(config1)
      .then((resp) => {
        console.log(resp.data, "resp")
        if (resp?.data) {
          setyear([...resp.data.data.exchange_info_list, 2024,2025].sort((a,b) => a - b));
        }
        return
      })
      .catch((err) => {
        console.log(err);
        toggleToaster(`Somethin went wrong`)
      });
  }

  async function getAllDistanceRanges(el, ref) {
    let config1 = {
      method: "get",
      url: `api/exchange/get-year-distance`,
      headers: {
        'x-flow': "BC_CREATE"
      },
      params: {
        model_ref: modelRef || ref,
        year: el
      }
    };
    await makeAPICall(config1)
      .then((resp) => {
        console.log(resp.data, "resp")
        if (resp?.data) {
          setRange(resp.data.data.exchange_info_list.sort((a,b) => a.from_distance - b.from_distance));
        }
        return
      })
      .catch((err) => {
        console.log(err);
        toggleToaster(`Somethin went wrong`)
      });
  }
  
  useEffect(()=>{
    if(previousExchangePartner){
     let previousPartner= exchangePatnerData.find((el) => el?.id === previousExchangePartner)
     setExchangePatner(previousPartner)
    }
  }, [previousExchangePartner, exchangePatnerData])


  const handleOrderTitle = (action) => {
    if (action == "CREATE_NEW" || action == "EXCHANGE_SOFT_REJECTED") {
       return "Create exchange offer"
    } else if (action == "VIEW_EDIT") {
       return "Edit exchange offer"
    } else if (action == "VERIFY_EXCHANGE") {
      return "Verify exchange offer"
    }
  }

  function handlePartnerSearch(val) {
    setSearchPartner(val)
    console.log(val, "inside search");
    let temp = JSON.parse(JSON.stringify(exchangePatnerData))
    setFilterPartnerArray(temp?.filter(el => new RegExp(val?.toLowerCase()).test(el?.partner_name?.toLowerCase())))
  }

  function handleBikeExchnage(el){
  setExchangeSelected(true)
  // Check if "Others" is selected
  if (el?.partner_name === "Others") {
    setShowCustomVendorInput(true)
    setCustomVendorName("")
    // Set exchangePatner with custom_vendor id
    setExchangePatner({
      id: 1,
      partner_name: "Others"
    })
  } else {
    setExchangePatner(el)
    setShowCustomVendorInput(false)
  }
  setShowExchangePatner(false)
}

  const handleBrandDropDown = (el) => {
     if (el === "Others") {
       setShowCustomBrandInput(true);
       setCustomBrandName("");
       setBrandName("Others");
       setBrandSelected(true);
       setShowBrand(false);
       // Reset dependent fields
       setModelName("");
       setModelSelected(false);
       setModelYear("");
       setModelYearSelected(false);
       setVariantName("");
       setColorName("");
       setKilometer({});
       setBikeRangeSelected(false);
       setSearchedBrand("");
       // Show custom inputs for model, variant, color when brand is Others
       setShowCustomModelInput(true);
       setCustomModelName("");
      setCustomVariantName("");
       setCustomColorName("");
       return;
     }
    //after selecting brand
    getAllModels(el)
    setModelName("");
    setModelSelected(false);
    setModelYear("");
    setModelYearSelected(false);
    setBrandName(el);
    setBrandSelected(true);
    setShowBrand(false);
    setVariantName("")
    setColorName("")
    setKilometer({})
    setBikeRangeSelected(false);

    setSearchedBrand("")
    setShowCustomBrandInput(false)
    setShowCustomModelInput(false)
  };

  
  const handleEcRegionDropDown = (el) => {
    getAllEcNames(el?.id)
    setEcRegion(el?.name)
    setEcRegionSelected(true)
    setShowEcRegion(false)
  }

  const handleEcNameDropDown = (el) => {
      setEcName(el?.name)
      setBusinessId(el?.businessUnitId)
      setEcNameSelected(true)
      setShowEcName(false)
  }

const onEcNameChange = () => {
  if (ecRegion) {
    setShowEcName(!showEcName)
  } else {
    toggleToaster("Please select Ec Region first")
  }
}
  const handleModelDropDown = (el) => {
    //after selecting model
    // setyear(el?.year);
    getAllVariants(el)

    setModelName(el);
    setModelSelected(true);
    setShowModel(false);
    setModelYear("");
    setModelYearSelected(false);
    setVariantName("")
    setColorName("")
    setKilometer({})
    setBikeRangeSelected(false);

    setSearchedModel("")
  };

  const handleVariantDropDown = (el) => {
    getAllColors(el)
    
    setVariantName(el)
    setShowVariant(false)
    setVariantSelected(true)
    setColorName("")
    setColorSelected(false)
    setModelYear("")
    setModelYearSelected(false)
    setKilometer({})
    setBikeRangeSelected(false);

    setSearchedVariant("")
  }
  
  const handleColorDropDown = (el) => {
    if (el === "Others") {
    setShowCustomColorInput(true);
    setCustomColorName("");
    setColorName("Others");
    setColorSelected(true);
    setShowColor(false);
    setModelYear("");
    setModelYearSelected(false);
    setKilometer({});
    setBikeRangeSelected(false);
    return;
    }
    getAllYears(el)
    setModelRef(el.model_ref)
    setColorName(colorGroups[el.color] ? colorGroups[el.color]?.join("/") : el.color)
    setColorGroupSelected(el.color)
    setShowColor(false)
    setColorSelected(true)
    setModelYear("")
    setModelYearSelected(false)
    setKilometer({})
    setBikeRangeSelected(false);
    setShowCustomColorInput(false);
  
    // setyear(brand.find((a) => a == brandName)?.models.find(model => model.model == modelName)?.variants.find(v => v.variant == variantName)?.colors.find(col => col.color == el)?.year)
  }

  const handleModelYearDropDown = (el) => {
    //after selecting year
    // getAllDistanceRanges(el)

    setModelYear(el);
    setModelYearSelected(true);
    setShowModelYear(false);
    setKilometer({})
    setBikeRangeSelected(false);
    // setTimeout(()=>setCallTime(!callTime), 100)
    // if (
    //   brandName &&
    //   modelName &&
    //   ownership &&
    //   (kilometer.from_distance || kilometer.to_distance)
    // ) {
    //   getExchangeOfferPrice({
    //     brand: brandName,
    //     model: modelName,
    //     year: el,
    //     from_distance: kilometer.from_distance,
    //     to_distance: kilometer.to_distance,
    //     ownership: ownership,
    //   });
    // }
  };

  const handleLoanDropDown = (el) => {
    //after selecting loan
    setBikeLoan(el);
    setBikeLoanSelected(true);
    setShowBikeLoan(false);
  };

  const handleConditionDropDown = (el) => {
    //after selecting condition
    setBikeCondtion(el);
    setBikeConditionSelected(true);
    setShowBikeCondition(false);
  };

  const handleRangeDropDown = (el) => {
    setKilometer(el);
    setBikeRangeSelected(true);
    setShowBikeRange(false);
    // setTimeout(()=>setCallTime(!callTime), 100)
    // if (brandName && modelName && modelYear && ownership) {
    //   getExchangeOfferPrice({
    //     brand: brandName,
    //     model: modelName,
    //     year: modelYear,
    //     from_distance: el.from_distance,
    //     to_distance: el.to_distance,
    //     ownership: ownership,
    //   });
    // }
  };
  const onChangeOfModel = () => {
    if (brandName) {
      setShowModel(!showModel);
    } else {
      toggleToaster(`Please select brand first`)
    }
  };

  const onChangeOfYear = () => {
    if (brandName && modelName && year?.length) {
      setShowModelYear(!showModelYear);
    } else {
      toggleToaster(`Please select model first`)
    }
  };

  const toggleToaster = (msg, time = 2000) => {
      setShowToggle(true)
      setToastMsg(msg)
      setTimeout(() => {
        setShowToggle(false)
        setToastMsg("")
      }, time)
  }

  const onOwnersNameChange = (val) => {
    let reg = /^[a-zA-Z0-9 ]{0,29}$/;
    if (reg.test(val.target.value)) {
      setOwnersName(val.target.value);
    }
  };

  const onCustomerNameChange = (val) => {
    let reg = /^[a-zA-Z0-9 ]{0,29}$/;
    if (reg.test(val.target.value)) {
      setCustomerName(val.target.value);
    }
  };

 


  const handleOwnershipDropDown = (el) => {
    //after selecting condition
    setOwnership(el);
    setOwnershipSelected(true);
    setShowOwnership(false);
    // if (brandName && modelName && modelYear && ownership) {
    //   getExchangeOfferPrice({
    //     brand: brandName,
    //     model: modelName,
    //     year: modelYear,
    //     from_distance: kilometer.from_distance,
    //     to_distance: kilometer.to_distance,
    //     ownership: el,
    //   });
    // }
  };

  const showConfirmPopup = (flag=false) => {
    if (!continueBtnDisabled) {
      handleSubmit(flag)
    setShowVerifyPopup(true)
    }
  };

  // const onFileChange = (evt, index) => {
  //   let allowedExtensions = /(\.jpg|\.jpeg|\.png|\.heic)$/i;
  //   const [file] = evt.target?.files;
  //   let extension = file?.name.substr(file?.name.lastIndexOf("."));
  //   let size = parseFloat(file?.size / (1024 * 1024)).toFixed(2); 
  //   if (allowedExtensions.exec(extension)) {
  //     if (size <= 7) {
  //       let mimeType = file?.type;
  //       let reader = new FileReader();
  //       let base64Version = '';
  //       reader.readAsDataURL(file);
  //       reader.onload = async function () {
  //         base64Version = reader.result;
  //         if (base64Version) {
  //           // vehConditionList[`preview-img-${index}`] = base64Version
  //           // setVehConditionList({
  //           //   ...vehConditionList
  //           // })
  //           saveEachDocument(`VEHICLE_CONDITION_${index + 1}`, base64Version)
  //         }
  //       };
  //       if (file) {
  //         if (extension == ".pdf" || extension == ".heic") {
  //           document.getElementById('preview-img-' + index).src = CheckTick
  //           document.getElementById('preview-img-' + index).style.width = "20%"
  //           document.getElementById('preview-img-' + index).style.left = "38%"
  //         } else {
  //           document.getElementById('preview-img-' + index).src = URL.createObjectURL(file);
  //           document.getElementById('preview-img-' + index).style.width = "100%"
  //           document.getElementById('preview-img-' + index).style.left = "0"
  //         }
  //       }
  //     } else {
  //       handleToast("please upload images less than 7 mb")
  //     }
  //   } else {
  //     handleToast("please upload images of type(jpeg,jpg,png,heic)")
  //   }
  // };

  const onRegFileChange = (evt, index, doc_type = "") => {  
    let allowedExtensions = /(\.jpg|\.jpeg|\.png|\.heic|\.pdf)$/i;
    const [file] = evt.target?.files;
    let extension = file?.name.substr(file?.name.lastIndexOf("."));
    let size = parseFloat(file?.size / (1024 * 1024)).toFixed(2); 
    if (allowedExtensions.exec(extension)) {
      if (size <= 7) {
        let mimeType = file?.type;
        let reader = new FileReader();
        let base64Version = '';
        reader.readAsDataURL(file);
        reader.onload = async function () {
          base64Version = reader.result;
          if (base64Version) {
            // scooterRegList[`reg-preview-img-${index}`] = base64Version
            // setScooterRegList({
            //   ...scooterRegList
            // })
            if (doc_type === "VEHICLE_CONDITION_1") {
              vehicleUploadStatus[0] = true
              setVehicleUploadStatus(vehicleUploadStatus)
              saveEachDocument(doc_type, base64Version, index)
            } else if (doc_type === "EXCHANGE_OPTIONAL_DOC_1") {
              optionalUploadStatus[0] = true
              setOptionalUploadStatus(optionalUploadStatus)
              saveEachDocument(doc_type, base64Version, index)
            }  else if (doc_type.includes("VEHICLE_CONDITION")) {
              if (vehicleUploadStatus[index - 1]) {
                vehicleUploadStatus[index] = true
                setVehicleUploadStatus(vehicleUploadStatus)
                 saveEachDocument(doc_type, base64Version, index)
              } else {
                handleToast(`please upload previous images `)
                return
              }
            } else if (doc_type.includes("EXCHANGE_OPTIONAL_DOC")) {
              if (optionalUploadStatus[index - 1]) {
                optionalUploadStatus[index] = true
                setOptionalUploadStatus(optionalUploadStatus)
                saveEachDocument(doc_type, base64Version, index)
              } else {
                handleToast(`please upload previous images `)
                return
              }
            } else if (!doc_type.includes("VEHICLE_CONDITION") && !doc_type.includes("EXCHANGE_OPTIONAL_DOC")) {
              saveEachDocument(doc_type, base64Version, index)
            }
          }
        };
        if (file) {
          if (extension == ".pdf" || extension == ".heic") {
            document.getElementById('reg-preview-img-' + index).src = CheckTick
            document.getElementById('reg-preview-img-' + index).style.width = "20%"
            document.getElementById('reg-preview-img-' + index).style.left = "38%"
          } else {
            if (doc_type.includes("VEHICLE_CONDITION")) {
                document.getElementById('reg-preview-img-vehicle-condition' + index).src = URL.createObjectURL(file);
            } else if (doc_type.includes("EXCHANGE_OPTIONAL_DOC")) {
                document.getElementById('reg-preview-img-optional' + index).src = URL.createObjectURL(file);
              }
            else if (doc_type.includes("SCOOTER_REGISTRATION")) {
              document.getElementById('reg-preview-img-registration' + index).src = URL.createObjectURL(file);
            } else if (doc_type.includes("EXCHANGE_FORM_")) {
              document.getElementById('reg-preview-img-form' + index).src = URL.createObjectURL(file);
            } else if (doc_type.includes("EXCHANGE_AUTH_LETTER")) {
              document.getElementById('reg-preview-img-kyc' + 0).src = URL.createObjectURL(file);
            }
            else if (doc_type.includes("EXCHANGE_KYC_DOC")) {
              document.getElementById('reg-preview-img-kyc' + 1).src = URL.createObjectURL(file);
            }
            document.getElementById('reg-preview-img-' + index).src = URL.createObjectURL(file);
            document.getElementById('reg-preview-img-' + index).style.width = "100%"
            document.getElementById('reg-preview-img-' + index).style.left = "0"
          }
        }
      } else {
        handleToast("please upload images less than 7 mb")
      }
    } else {
      handleToast("please upload images of type(jpeg,jpg,png)")
    }
  };

  const saveDetails = (flag = false, confirmClicked = false) => { 
    if (continueBtnDisabled) return;
    let config = {
      method: "put",
      url: `api/exchange/saveExchange`,
      params: {
        ...orderUserData,
      },
      data: {
        ...bikePayload,
      },
    };

    makeAPICall(config)
      .then((resp) => {
        if (resp && resp.data.status === "SUCCESSFUL") {
        }
        if(orderUserData?.action == "EXCHANGE_SOFT_REJECTED") {
          verifyExchange("VERIFIED");
          return
        }
        if (!flag) { 
          setShowVerifyPopup(false)
        }
        // handleToast("Successfully verified")
        // setPreviousBikeData(resp.data);
        if (!flag) {
          setTimeout(() => {
            history.push({
              pathname: "/scooter-exchange-data", 
              state: {
                ...history.location.state,showtoggle:true
              }
            });
          }, 3000)
        }
        if (flag) {
          setIsLoading(false)
        }
      })
      .catch((err) => {
        setShowVerifyPopup(false)
        // toggleToaster(`Somethin went wrong`)

        if(err?.response?.data?.status == "EXCHANGE_VALUE_MORE_THAN_BALANCE_AMOUNT") {
          setShowSplitErrorPopup(true);
        }

        setTimeout(() => {
          err?.response?.data?.status && handleToast(err?.response?.data?.status, 3000)
        }, 100)
        setIsLoading(false)
      });
  }

  const verifyExchange = (types) => {

    let config = {
      method: "put",
      url: `api/exchange/verifyExchange`,
      params: {
        ...orderUserData,
      },
      data: {
        status: types,
        message: "",
      },
    };

    makeAPICall(config)
      .then((resp) => {
        if (resp && resp.data.status === "SUCCESSFUL") {
        handleToast("Successfully verified")
        setTimeout(() => history.replace({
          pathname: "/search-exchange", 
        }), 3000)
        }
      })
      .catch((err) => {
        console.log("failed");
        // setLoader(false);
      });
  };

  const saveEachDocument = (type, file,index="") => {
    let fileBody = {
      file: file,
      type: type,
      view: "FRONT",
      data: {},
      is_address_proof: false,
    }
    if (type ==="SCOOTER_REGISTRATION" && index === 1) {
      fileBody.view="BACK"
    }
    if (type === "EXCHANGE_FORM_30" && index === 2) {
      fileBody.view = "BACK"
    }
    let uploadBody = {
      address_proof: "",
      already_uploaded: false,
      order_id: orderUserData?.order_id,
      files: [fileBody],
    };
    let config = {
      method: "put",
      url: `api/exchange/uploadScooter`,
      params: {
        ...orderUserData,
      },
      data: { ...uploadBody },
    };

    setIsLoading(true)

    makeAPICall(config)
      .then((resp) => {
        if (resp && resp.data?.status === "SUCCESS") {
          setIsLoading(false)
          // saveDetails()
          if (type.includes("SCOOTER_REGISTRATION")) {
            document.getElementById('reg-preview-img-registration' + index).style.border = '2px solid lawngreen';
            scooterRegList[`reg-preview-img-registration${index}`] = file
            setScooterRegList({
              ...scooterRegList
            })
          } else if (type.includes("VEHICLE_CONDITION_")) {
            document.getElementById('reg-preview-img-vehicle-condition' + index).style.border = '2px solid lawngreen';
            vehConditionList[`reg-preview-img-vehicle-condition${index}`] = file
            setVehConditionList({
              ...vehConditionList
            })
          }  else if (type.includes("EXCHANGE_FORM_")) {
            document.getElementById('reg-preview-img-form' + index).style.border = '2px solid lawngreen';
            formImageList[`reg-preview-img-form${index}`] = file
            setFormImageList({
              ...formImageList
            })
          } else if (type.includes("EXCHANGE_AUTH_LETTER")) {
            document.getElementById('reg-preview-img-kyc' + 0).style.border = '2px solid lawngreen';
            kycDocList[`reg-preview-img-kyc0`] = file
            setDocList({
              ...kycDocList
            })
          } else if (type.includes("EXCHANGE_KYC_DOC")) {
            document.getElementById('reg-preview-img-kyc' + 1).style.border = '2px solid lawngreen';
            kycDocList[`reg-preview-img-kyc1`] = file
            setDocList({
              ...kycDocList
            })
          } else if (type.includes("EXCHANGE_OPTIONAL_DOC")) {
            document.getElementById('reg-preview-img-optional' + index).style.border = '2px solid lawngreen';
            optionalList[`reg-preview-img-optional${index}`] = file
            setOptionalList({
              ...optionalList
            })
          } else {
            let index = type.split(`VEHICLE_CONDITION_`)[1]
            document.getElementById('preview-img-' + (index-1)).style.border = '2px solid lawngreen';
            vehConditionList[`preview-img-${index-1}`] = file
            setVehConditionList({
              ...vehConditionList
            })
          }
        }
      })
      .catch((err) => {
        setIsLoading(false)
        if (type === "SCOOTER_REGISTRATION") {
          document.getElementById('reg-preview-img-' + 0).style.border = '2px solid red'
        } else {
          let index = type.split(`VEHICLE_CONDITION_`)[1]
          document.getElementById('preview-img-' + index).style.border = '2px solid red'
        }
      });
  }

  const saveDocuments = () => {

   let scooterImages = []
   let regImages = []
   if (vehConditionList) {
     scooterImages = Object.values(vehConditionList)
   }

   if (scooterRegList) {
    regImages = Object.values(scooterRegList)  
   }

    let finalArr = [];
    scooterImages.map((a) =>
      finalArr.push({
        file: a,
        type: "VEHICLE_CONDITION",
        view: "FRONT",
        data: {},
        is_address_proof: false,
      })
    );

    regImages.map((a) =>
      finalArr.push({
      file: a,
      type: "SCOOTER_REGISTRATION",
      view: "FRONT",
      data: {},
      is_address_proof: false,
    })
  );

    let uploadBody = {
      address_proof: "",
      already_uploaded: false,
      order_id: orderUserData?.order_id,
      files: [...finalArr],
    };
    let config = {
      method: "put",
      url: `api/exchange/uploadScooter`,
      params: {
        ...orderUserData,
      },
      data: { ...uploadBody },
    };

    makeAPICall(config)
      .then((resp) => {
        if (resp && resp.data?.status === "SUCCESS") {
          saveDetails()
        }
      })
      .catch((err) => {
        setIsLoading(false)
      });
  }

  const handleSubmit = (flag = false,confirmClicked=false) => {
    if (!isLoading) {
      setIsLoading(true)
      if (false && orderUserData?.action == "CREATE_NEW") {
       saveDocuments()
      } else {
        saveDetails(flag, confirmClicked)
      }
    }
  }

  const handleToast = (msg, timer) => {
    setToastMessage(msg);
    setShowToast('block');
    setTimeout(() => {
      setShowToast('none');
    }, timer || 2000);
  }


  const onChangeOfVariant = () => {
    if (brandName && modelName) {   
        setShowVariant(!showVariant)
    }
    else {
        toggleToaster(`Please select brand and model first`)
    }
}

const onChangeOfColor = () => {
    if (brandName && modelName && variantName) {   
        setShowColor(!showColor)
    }
    else {
        toggleToaster(`Please select brand, model and variant first`)

    }
}



  return (
    <>
      <div className="loan-container eb-input-section-main-wrapper">
        <div className="backArrow" style={{ marginLeft: "0" }} onClick={() => {
          history.goBack();
        }}>
          {/* <Link
            to={{
              pathname: `/scooter-exchange-data`,
              state: {
                ...orderUserData,
              },
            }}
          > */}
            <BackArrow removeClass={true} />
          {/* </Link> */}
        </div>
        <div>
          <div style={{ margin: "0" }} className="header-text">
            {handleOrderTitle(orderUserData?.action)}
          </div>
          <div
            style={{ margin: "0", marginBottom: "24px" }}
            className="popup-sub"
          >
            {history.location.state?.order_id}
          </div>
        </div>
        <div className="eb-brand-input-div">
          <div className="eb-brand-selection-div eb-single-inp-div vendor-section">
            {/* exchange patner */}
            <div className="vendor-title">VENDOR</div>
            <div className="eb-condition-selection-div eb-single-inp-div">
            {!showCustomVendorInput ? (
              <FloatingSelect
                labelName={"Vendor"}
                inputValue={exchangePatner?.partner_name}
                onChange={() => setShowExchangePatner(!showExchangePatner)}
                isSelected={exchangeSelected}
              />
            ) : (
              <div>
                <FloatingInput
                  id="custom_vendor"
                  onBlur={() => {}}
                  onFocus={() => {}}
                  name="customVendor"
                  type="text"
                  maxLength="50"
                  labelName="Vendor Name"
                  inputValue={customVendorName}
                  onChange={(val) => {
                    setCustomVendorName(val.target.value);
                    setExchangePatner({
                      ...exchangePatner, 
                      partner_name: val.target.value,
                      id: 1
                    });
                  }}
                  placeholder="Vendor name"
                  className={"eb-floatingInput"}
                />
                 {customVendorName && (
                    <div 
                      style={{fontSize: '12px', color: '#e74c3c', marginTop: '5px', fontWeight: '500'}}
                    >
                      Not a verified vendor. Please verify the vendor first
                    </div>
                  )}
                <div 
                  style={{fontSize: '12px', color: '#666', marginTop: '5px', cursor: 'pointer'}}
                  onClick={() => {
                    setShowCustomVendorInput(false);
                    setCustomVendorName("");
                    setExchangePatner({});
                    setExchangeSelected(false);
                  }}
                >
                  ← Back to vendor list
                </div>
              </div>
            )}
            </div>
            <div className="eb-condition-selection-div eb-single-inp-div">
              <FloatingSelect
                labelName={"Ec Region"}
                inputValue={ecRegion}
                onChange={() => setShowEcRegion(!showEcRegion)}
                isSelected={ecRegionSelected}
              />
            </div>

            <div className="eb-condition-selection-div eb-single-inp-div">
              <FloatingSelect
                labelName={"Ec Name"}
                inputValue={ecName}
                onChange={() => onEcNameChange()}
                isSelected={ecNameSelected}
              />
            </div>
          </div>
          <div className="eb-brand-selection-div eb-single-inp-div">
            {/* brand  */}
            <div className="vendor-title">BIKE DETAILS</div>
            {!showCustomBrandInput ? (
            <FloatingSelect
              labelName={"Brand"}
              inputValue={brandName}
              onChange={() => setShowBrand(!showBrand)}
              isSelected={brandSeleceted}
            />
            ) : (
              <div>
              <FloatingInput
                id="custom_brand"
                onBlur={() => {}}
                onFocus={() => {}}
                name="customBrand"
                type="text"
                maxLength="50"
                labelName="Brand Name"
                inputValue={customBrandName}
                onChange={(val) => {
                  setCustomBrandName(val.target.value);
                  setBrandName(val.target.value);
                }}
                placeholder="Brand name"
                className={"eb-floatingInput"}
              />
              <div 
                style={{fontSize: '12px', color: '#666', marginTop: '5px', cursor: 'pointer'}}
                onClick={() => {
                  setShowCustomBrandInput(false);
                  setShowCustomModelInput(false);
                  setCustomBrandName("");
                  setBrandName("");
                  setBrandSelected(false);
                  // Reset all dependent fields
                  setModelName("");
                  setModelSelected(false);
                  setModelYear("");
                  setModelYearSelected(false);
                  setVariantName("")
                  setColorName("")
                  setKilometer({})
                  setBikeRangeSelected(false);
                }}
              >
                ← Back to brand list
              </div>
            </div>
          )}
          </div>
          <div className="eb-model-selection-div eb-single-inp-div">
            {/* model */}
            {showCustomModelInput ? (
              <FloatingInput
                id="custom_model"
                name="custom_model"
                type="text"
                labelName="Model"
                maxLength="50"
                inputValue={customModelName}
                onChange={(e) => {
                  setCustomModelName(e.target.value);
                  setModelName(e.target.value);
                }}
                placeholder="Model"
                className={"eb-floatingInput"}
              />
            ) : (
              <FloatingSelect
                labelName={"Model"}
                inputValue={modelName}
                onChange={() => onChangeOfModel()}
                isSelected={modelSeleceted}
              />
            )}
          </div>
          <div className='eb-model-selection-div eb-single-inp-div'>
              {/* variant */}
              {showCustomModelInput ? (
                <FloatingInput
                  id="custom_variant"
                  name="custom_variant"
                  type="text"
                  maxLength="50"
                  labelName="Variant"
                  inputValue={customVariantName}
                  onChange={(e) => {
                    setCustomVariantName(e.target.value);
                    setVariantName(e.target.value); 
                  }}
                  placeholder="Variant"
                  className={"eb-floatingInput"}
                />
              ) : (
                <FloatingSelect
                  labelName={"Variant"}
                  inputValue={variantName}
                  onChange={() => onChangeOfVariant() }
                  isSelected={variantSeleceted}
                />
              )}
          </div>
          <div className='eb-model-selection-div eb-single-inp-div'>
            {/* color */}
            {showCustomModelInput || showCustomColorInput ? (
              <div>
              <FloatingInput
                id="custom_color"
                name="custom_color"
                type="text"
                labelName="Color"
                maxLength="20"
                inputValue={customColorName}
                onChange={(e) => {
                  setCustomColorName(e.target.value);
                  setColorName(e.target.value); 
                }}
                placeholder="Color"
                className={"eb-floatingInput"}
              />
              {showCustomColorInput && (
                <div 
                  style={{fontSize: '12px', color: '#666', marginTop: '5px', cursor: 'pointer'}}
                  onClick={() => {
                    setShowCustomColorInput(false);
                    setCustomColorName("");
                    setColorName("");
                    setColorSelected(false);
                  }}
                >
                  ← Back to color list
                </div>
              )}
              </div>
            ) : (
              <FloatingSelect
                labelName={"Color"}
                inputValue={colorName}
                onChange={() => onChangeOfColor() }
                isSelected={colorSeleceted}
              />
            )}
          </div>
          <div className="eb-year-selection-div eb-single-inp-div">
            {/* year */}
             {showCustomModelInput || showCustomColorInput ? (
              <FloatingInput
                id="custom_year"
                name="custom_year"
                type="text"
                labelName="Year of manufacture"
                inputValue={modelYear}
                onChange={(e) => {
                  const currentYear = new Date().getFullYear();
                  const enteredValue = e.target.value;
                  if (!/^\d*$/.test(enteredValue)) {
                    return;
                  }
                  if (enteredValue.length === 4) {
                    const enteredYear = parseInt(enteredValue);
                    if (enteredYear > currentYear) {
                      handleToast(`Year cannot be greater than ${currentYear}`);
                      setModelYear("");
                      setModelYearSelected(false);
                      return;
                    }
                  }
                  setModelYear(e.target.value);
                  setModelYearSelected(true);
                }}
                placeholder="Year of manufacture"
                className={"eb-floatingInput"}
                maxLength="4"
              />
            ) : (
              <FloatingSelect
                labelName={"Year of manufacture"}
                inputValue={modelYear}
                onChange={() => onChangeOfYear()}
                isSelected={modelYearSeleceted}
              />
            )}
          </div>
          {/* <div className='eb-single-inp-div'>
            { Pincode of reg }
            <FloatingInput
                id="number"
                onBlur={() => {}}
                onFocus={() => {}}
                name="regNum"
                type="number"
                maxLength="6"
                labelName="PIN code of registration"
                inputValue={pincode}
                onChange={(val) => {setPincode(val)}}
                placeholder="PIN code of registration"
                className={"eb-floatingInput"}
            />
          </div> */}
          <div className="eb-single-inp-div">
            {/* kilometer range */}
            <FloatingSelect
              labelName={"Kilometre range"}
              inputValue={
                (kilometer.from_distance >= 60000 && kilometer.from_distance == 300000) ? `Greater than ${kilometer.from_distance}` : kilometer.from_distance + " - " + kilometer.to_distance
              }
              onChange={() => setShowBikeRange(!showBikeRange)}
              isSelected={bikeRangeSelected}
            />
          </div>
          <div className="eb-loan-selection-div eb-single-inp-div">
            {/* loan */}
            <FloatingSelect
              labelName={"Loan"}
              inputValue={bikeLoan}
              onChange={() => setShowBikeLoan(!showBikeLoan)}
              isSelected={bikeLoanSeleceted}
            />
            {bikeLoan === "Pending" && (
              <p className="notEligible">Not eligible for exchange program</p>
            )}
          </div>
          <div className="eb-condition-selection-div eb-single-inp-div">
            {/* condtion */}
            <FloatingSelect
              labelName={"Vehicle Condition"}
              inputValue={bikeCondtion}
              onChange={() => setShowBikeCondition(!showBikeCondition)}
              isSelected={bikeConditionSeleceted}
            />
            {bikeCondtion === "Not working" && (
              <p className="notEligible">Not eligible for exchange program</p>
            )}
          </div>

          <div className="eb-condition-selection-div eb-single-inp-div">
            <FloatingSelect
              labelName={"Ownership"}
              inputValue={ownershipMap[ownership]}
              onChange={() => setShowOwnership(!showOwnership)}
              isSelected={ownershipSeleceted}
            />
          </div>
          

          {/* <div className="eb-single-inp-div">
            <FloatingInput
              id="full_name"
              onBlur={() => { }}
              onFocus={() => { }}
              name="ecRegion"
              type="text"
              maxLength="30"
              labelName="Ec Region"
              inputValue={previousBikeData?.ec_region || ecRegion}
              onChange={(val) => {
                onEcRegionChange(val);
              }}
              placeholder="Ec Region"
              className={"eb-floatingInput"}
            />
          </div>

          <div className="eb-single-inp-div">
            <FloatingInput
              id="full_name"
              onBlur={() => { }}
              onFocus={() => { }}
              name="ecName"
              type="text"
              maxLength="30"
              labelName="Ec Name"
              inputValue={previousBikeData?.ec_name || ecName}
              onChange={(val) => {
                onEcNameChange(val);
              }}
              placeholder="Ec Name"
              className={"eb-floatingInput"}
            />
          </div> */}


          <div className="eb-single-inp-div">
            {/* owner name */}
            <FloatingInput
              id="full_name"
              onBlur={() => {}}
              onFocus={() => {}}
              name="ownerName"
              type="text"
              maxLength="30"
              labelName="Owner’s name (As per the RC)"
              inputValue={previousBikeData?.owner_name || ownersName}
              onChange={(val) => {
                onOwnersNameChange(val);
              }}
              placeholder="Owner’s name (As per the RC)"
              className={"eb-floatingInput"}
            />
          </div>

          <div className="eb-single-inp-div">
            {/* customer name */}
            <FloatingInput
              id="full_name"
              onBlur={() => { }}
              onFocus={() => { }}
              name="customerName"
              type="text"
              maxLength="30"
              labelName="Customer name"
              inputValue={previousBikeData?.customer_name || customerName}
              onChange={(val) => {
                onCustomerNameChange(val);
              }}
              placeholder="Customer name"
              className={"eb-floatingInput"}
            />
          </div>

          <div className="eb-single-inp-div">
            <FloatingInput
              id="registrationNo"
              onBlur={() => {}}
              onFocus={() => {}}
              name="Registration Number"
              type="text"
              maxLength="10"
              labelName="Registration Number"
              inputValue={previousBikeData?.other_attributes?.registration_number || registrationNo}
              onChange={(val) => setRegistrationNo(val)}
              placeholder="Registration Number"
              className={"eb-floatingInput"}
            />
          </div>

          <div className="eb-single-inp-div">
            <FloatingInput
              id="currency-IN"
              onBlur={() => {}}
              onFocus={() => {}}
              name="Exchange value"
              type="text"
              labelName="Exchange value"
              inputValue={previousBikeData?.exchange_value || exchangeValue}
              onChange={(val) => {
                setExchangeValue(val)
              }}
              placeholder="Exchange value"
              className={"eb-floatingInput"}
              disabled={orderUserData?.action == "EXCHANGE_SOFT_REJECTED"}
            />
          </div>
          {/* Input for Transaction Id */}
          {/* commented for release uncomment when backend supports */}
          {/* <div className="eb-single-inp-div">
            <FloatingInput
              id="registrationNo"
              onBlur={() => {}}
              onFocus={() => {}}
              name="Transaction ID"
              type="text"
              labelName="Transaction ID"
              inputValue={previousBikeData?.transaction_id || transactionId}
              onChange={(val) => {
                setTransactionId(val)
              }}
              placeholder="Transaction ID"
              className={"eb-floatingInput"}
            />
          </div> */}
          {/* <div className="eb-single-inp-div">
           Bike reg num
          <FloatingInput
            id="username"
            onBlur={() => {
              checkValidOwnerName(regNumber);
            }}
            onFocus={() => {
              checkValidOwnerName(regNumber);
            }}
            name="regNum"
            type="text"
            maxLength="30"
            labelName="Registration Number"
            inputValue={
              previousBikeData?.other_attributes?.owner_name || regNumber
            }
            onChange={(val) => {
              setRegNumber(val.target.value);
            }}
            placeholder="Registration Number"
            className={"eb-floatingInput"}
          />
        </div>*/} 
        {
          true && (
            <div className="uploadWrapper">
            <p className="title">
            OLD 2-WHEELER PICTURES
            </p>
            {/* <p className="uploadDocTitle">
              Scooter Registration* (please upload atleast 1 image)
            </p> */}
            <div className="uploadImgWrapper">
              {
                new Array(scooterRegImgLimit).fill(1)?.map((list, index) => (
                  <div key={index} className="uploadImage old-2-wheeler-picture">
                    {
                      !vehConditionList?.["reg-preview-img-vehicle-condition" + index] && (
                        <div className="file-upload-details">
                          <img className="plus-icon" src={PlusIcon} alt="" />
                          <div>{index === 0 ? "Front" : index === 1 ? "Rear" : index === 2 ? "Left" : index === 3 ? "Right" : "Boot"}</div>
                        </div>
                      )
                    }
                      <input
                        className="input-file"
                        id={'uploadInput-1-' + index}
                        type="file"
                        data
                      onChange={(evt) => onRegFileChange(evt, index, `VEHICLE_CONDITION_${index+1}`)}
                      />
                       <div
                      style={{ display: vehConditionList?.["reg-preview-img-vehicle-condition" + index] ? 'block' : 'none' }}
                        className="upload-preview-img"
                      >
                        <img className="previewImg" id={"reg-preview-img-vehicle-condition" + index} src="#" alt="" />  
                      </div>
                  </div>
                ))
              }
                </div>
                {/* =============================== */}
                
                <p className="title">
                  REGISTRATION CERTIFICATE
                </p>
                {/* <p className="uploadDocTitle">
              Scooter Registration* (please upload atleast 1 image)
            </p> */}
                <div className="uploadImgWrapper">
                  {
                    new Array(registration_certificate).fill(1)?.map((list, index) => (
                      <div key={index} className="uploadImage old-2-wheeler-picture">
                        {
                          !scooterRegList?.["reg-preview-img-registration" + index] && (
                            <div className="file-upload-details">
                              <img className="plus-icon" src={PlusIcon} alt="" />
                              <div>{index==0?"Front":"Back"}</div>
                            </div>
                          )
                        }
                        <input
                          className="input-file"
                          id={'uploadInput-1-' + index}
                          type="file"
                          data
                          onChange={(evt) => onRegFileChange(evt, index,"SCOOTER_REGISTRATION")}
                        />
                        <div
                          style={{ display: scooterRegList?.["reg-preview-img-registration" + index] ? 'block' : 'none' }}
                          className="upload-preview-img"
                        >
                          <img className="previewImg" id={"reg-preview-img-registration" + index} src="#" alt="" />
                        </div>
                      </div>
                    ))
                  }
                </div>

                {/* =============================== */}

                <p className="title">
                  FORM 29 & 30
                </p>
                {/* <p className="uploadDocTitle">
              Scooter Registration* (please upload atleast 1 image)
            </p> */}
                <div className="uploadImgWrapper">
                  {
                    new Array(form_length).fill(1)?.map((list, index) => (
                      <div key={index} className="uploadImage old-2-wheeler-picture">
                        {
                          !formImageList?.["reg-preview-img-form" + index] && (
                            <div className="file-upload-details">
                              <img className="plus-icon" src={PlusIcon} alt="" />
                              <div>Form {index==0 ? "29" : index === 1?"30 Front": "30 Back" }</div>
                            </div>
                          )
                        }
                        <input
                          className="input-file"
                          id={'uploadInput-1-' + index}
                          type="file"
                          accept=".jpg,.jpeg,.png,.heic,.pdf"
                          data
                          onChange={(evt) => onRegFileChange(evt, index, index == 0 ? "EXCHANGE_FORM_29" :  "EXCHANGE_FORM_30")}
                        />
                        <div
                          style={{ display: formImageList?.["reg-preview-img-form" + index] ? 'block' : 'none' }}
                          className="upload-preview-img"
                        >
                          <img className="previewImg" id={"reg-preview-img-form" + index} src="#" alt="" />
                        </div>
                      </div>
                    ))
                  }
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                <div style={{ display: 'flex', gap: '10px' }}>
                  <a
                    href="/samples/Form 29.pdf"
                    download="Form-29-Sample.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      color: '#007bff',
                      textDecoration: 'underline',
                      fontSize: '12px',
                      cursor: 'pointer'
                    }}
                  >
                    Form 29 Sample
                  </a>
                  <a
                    href="/samples/Form 30.pdf"
                    download="Form-30-Sample.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      color: '#007bff',
                      textDecoration: 'underline',
                      fontSize: '12px',
                      cursor: 'pointer'
                    }}
                  >
                    Form 30 Sample
                  </a>
                </div>
              </div>

                {/* =============================== */}


                <p className="title">
                  KYC Documents
                </p>
                {/* <p className="uploadDocTitle">
              Scooter Registration* (please upload atleast 1 image)
            </p> */}
                <div className="uploadImgWrapper">
                  {
                    new Array(kyc_doc).fill(1)?.map((list, index) => (
                      <div key={index} className="uploadImage old-2-wheeler-picture">
                        {
                          !kycDocList?.["reg-preview-img-kyc" + index] && (
                            <div className="file-upload-details">
                              <img className="plus-icon" src={PlusIcon} alt="" />
                              <div>{index==0 ? "Auth Letter" :"Kyc Doc"}</div>
                            </div>
                          )
                        }
                        <input
                          className="input-file"
                          id={'uploadInput-1-' + index}
                          type="file"
                          accept=".jpg,.jpeg,.png,.heic,.pdf"
                          data
                          onChange={(evt) => onRegFileChange(evt, index, index === 0 ? "EXCHANGE_AUTH_LETTER" :"EXCHANGE_KYC_DOC")}
                        />
                        <div
                          style={{ display: kycDocList?.["reg-preview-img-kyc" + index] ? 'block' : 'none' }}
                          className="upload-preview-img"
                        >
                          <img className="previewImg" id={"reg-preview-img-kyc" + index} src="#" alt="" />
                        </div>
                      </div>
                    ))
                  }
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                  <div style={{ display: 'flex', gap: '10px' }}>
                    <a
                      href="/samples/Auth letter for exchange.pdf"
                      download="Auth-Letter-Sample.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        color: '#007bff',
                        textDecoration: 'underline',
                        fontSize: '12px',
                        cursor: 'pointer'
                      }}
                    >
                      Auth Letter Sample
                    </a>
                  </div>
                </div>

                
                <p className="title">
                  Optional
                </p>
                {/* <p className="uploadDocTitle">
              Scooter Registration* (please upload atleast 1 image)
            </p> */}
                <div className="uploadImgWrapper">
                  {
                    new Array(optional_length).fill(1)?.map((list, index) => (
                      <div key={index} className="uploadImage old-2-wheeler-picture">
                        {
                          !optionalList?.["reg-preview-img-optional" + index] && (
                            <div className="file-upload-details">
                              <img className="plus-icon" src={PlusIcon} alt="" />
                              <div>Image { index+1}</div>
                            </div>
                          )
                        }
                        <input
                          className="input-file"
                          id={'uploadInput-1-' + index}
                          type="file"
                          data
                          onChange={(evt) => onRegFileChange(evt, index, `EXCHANGE_OPTIONAL_DOC_${index+1}`)}
                        />
                        <div
                          style={{ display: optionalList?.["reg-preview-img-optional" + index] ? 'block' : 'none' }}
                          className="upload-preview-img"
                        >
                          <img className="previewImg" id={"reg-preview-img-optional" + index} src="#" alt="" />
                        </div>
                      </div>
                    ))
                  }
                </div>
            {/* <p className="deleteTitle" onClick={() => setScooterRegList({})}>
              *Remove Scooter Registration Images
            </p>
   */}
                
            {/* <p className="uploadDocTitle">
              Vehicle Condition* (please upload atleast 2 images)
            </p>
  
            <div className="uploadImgWrapper">
              {
                new Array(vehConditionLimit).fill(1)?.map((list, index) => (
                  <div key={index} className="uploadImage">
                    {
                      !vehConditionList?.["preview-img-" + index] && (
                        <img className="plus-icon" src={PlusIcon} alt="" />
                      )
                    }
                      
                      <input
                        className="input-file"
                        id={'uploadInput-2-' + index}
                        type="file"
                        data
                        onChange={(evt) => onFileChange(evt, index)}
                      />
                       <div
                        style={{ display: vehConditionList?.["preview-img-" + index] ? 'block' : 'none' }}
                        className="upload-preview-img"
                      >
                        <img className="previewImg" id={"preview-img-" + index} src="#" alt="" />  
                      </div>
                  </div>
                ))
              }
            </div> */}
            {/* <p className="deleteTitle" onClick={() => {
              setVehConditionList({})
            }}>
              *Remove Vehicle Condition Images
            </p> */}
          </div>
          )
        }

        </div>
        <div className="customer-name-check-wrapper">
          <div className="tick-section">
            {checkedStatus && <img onClick={() => { setCheckedStatus(false) }} className="checked" src={Tick} alt="" />}
            {!checkedStatus && <div onClick={() => { setCheckedStatus(true) }} className="unchecked"></div>}
          </div>
          <div>Customer's name on the RC copy of the used two-wheeler matches the name on the documents submitted to purchase the new Ola Scooter.</div>
        </div>
        <div>
          <button
            onClick={() => { showConfirmPopup(true) }}
            className="primary-btn"
            style={{
              cursor: continueBtnDisabled ? "disabled" : "pointer",
              background: continueBtnDisabled ? "rgba(0, 0, 0, 0.36)" : "black",
              width: '100%'
            }}
          >
            Next
          </button>
        </div>

        {showToggle && <div className="toaster">{toastMsg}</div>}

        {/* exchange drop down */}

        {showExchangePatner && 
          <div className="eb-brand-drop-down eb-common-drop-down-container">
            <GenericModal
              onClose={() => {
                setShowExchangePatner(false);
                handlePartnerSearch("")
              }}
              showClose={false}
              botSheet={true}
            >
              <div className="eb-inside-generic-brand-drop-down eb-common-div">
                <div className="eb-bike-title eb-drop-down-title">
                  2-Wheeler Exchange Partner
                </div>
                <div style={{marginBottom:'20px'}} className="search-by-exchange-partner">
                  <FloatingInput
                    id="exchange_partner"
                    name="exchange_partner"
                    type="text"
                    labelName="search exchange partner"
                    inputValue={searchPartner}
                    onChange={(val) => { handlePartnerSearch(val?.target?.value) }}
                    placeholder="Search Exchange Partner"
                    className={"eb-floatingInput"}
                    maxLength="10"
                  />
                </div>
                <div className="brand-options-div eb-drop-down-options exchange-partner-map-div">
                  <>
                    <div
                      className="eb-individual-brand-drop-down-div eb-common-single-div"
                      key="others"
                      onClick={() => { handleBikeExchnage({ partner_name: "Others" }) }}
                    >
                      Others
                    </div>
                    {filterPartnerArray?.map((el, i) => {
                    return <> <div
                      className="eb-individual-brand-drop-down-div eb-common-single-div"
                      key={i}
                      onClick={
                        () => { handleBikeExchnage(el) }
                      }
                    >
                      {el?.partner_name}
                    </div>
                    </>
                  })}
                  </>
                </div>
              </div>
            </GenericModal>
          </div>
        }

        {/* Brand drop down */}
        {showBrand && (
          <div className="eb-brand-drop-down eb-common-drop-down-container">
            <GenericModal
              onClose={() => {
                setShowBrand(false);
                setSearchedBrand("")
              }}
              showClose={false}
              botSheet={true}
            >
              <div className="eb-inside-generic-brand-drop-down eb-common-div">
                <div className="eb-bike-title eb-drop-down-title">
                  Brand
                </div>
                <div style={{marginBottom:'20px'}} className="search-by-exchange-partner">
                  <FloatingInput
                    id="vehicle_brand"
                    name="vehicle_brand"
                    type="text"
                    labelName="search vehicle brand"
                    inputValue={searchedBrand}
                    onChange={(val) => { setSearchedBrand(val?.target?.value) }}
                    placeholder="Search Vehicle Brand"
                    className={"eb-floatingInput"}
                    maxLength="10"
                  />
                </div>
                <div className="brand-options-div eb-drop-down-options exchange-partner-map-div">
                <div
                  className="eb-individual-brand-drop-down-div eb-common-single-div"
                  key="others"
                  onClick={() => { handleBrandDropDown("Others") }}
                >
                  Others
                </div>
                  {searchedBrand.length == 0 ? brands.map((el, i) => (
                    <div
                      onClick={() => {
                        handleBrandDropDown(el);
                      }}
                      className="eb-individual-brand-drop-down-div eb-common-single-div"
                      key={i}
                    >
                      {el}
                    </div>
                  )) : brands.filter((a) => a.toLocaleLowerCase().includes(searchedBrand.toLocaleLowerCase())).map((el, i) => (
                    <div
                      onClick={() => {
                        handleBrandDropDown(el);
                      }}
                      className="eb-individual-brand-drop-down-div eb-common-single-div"
                      key={i}
                    >
                      {el}
                    </div>
                  ))}
                </div>
              </div>
            </GenericModal>
          </div>
        )}

        {/* Bike model drop down */}
        {showModel && (
          <div className="eb-model-drop-down  eb-common-drop-down-container">
            <GenericModal
              onClose={() => {
                setShowModel(false);
                setSearchedModel("")
              }}
              showClose={false}
              botSheet={true}
            >
              <div className="eb-inside-generic-model-drop-down eb-common-div">
                <div className="eb-bike-title eb-drop-down-title">
                  Model
                </div>
                <div style={{marginBottom:'20px'}} className="search-by-exchange-partner">
                  <FloatingInput
                    id="vehicle_model"
                    name="vehicle_model"
                    type="text"
                    labelName="search vehicle model"
                    inputValue={searchedModel}
                    onChange={(val) => { setSearchedModel(val?.target?.value) }}
                    placeholder="Search Vehicle Model"
                    className={"eb-floatingInput"}
                    maxLength="10"
                  />
                </div>
                <div className="model-options-div eb-drop-down-options exchange-partner-map-div">
                  {searchedModel.length == 0 ? models.map((el, i) => (
                    <div
                      onClick={() => {
                        handleModelDropDown(el);
                      }}
                      className="eb-individual-model-drop-down-div eb-common-single-div"
                      key={i}
                    >
                      {el}
                    </div>
                  )) : models.filter((a) => a.toLocaleLowerCase().includes(searchedModel.toLocaleLowerCase())).map((el, i) => (
                    <div
                      onClick={() => {
                        handleModelDropDown(el);
                      }}
                      className="eb-individual-model-drop-down-div eb-common-single-div"
                      key={i}
                    >
                      {el}
                    </div>
                  ))}
                </div>
              </div>
            </GenericModal>
          </div>
        )}

        {/* Bike year drop down */}
        {showModelYear && (
          <div className="eb-modelYear-drop-down  eb-common-drop-down-container">
            <GenericModal
              onClose={() => {
                setShowModelYear(false);
              }}
              showClose={false}
              botSheet={true}
            >
              <div className="eb-inside-generic-modelYear-drop-down eb-common-div">
                <div className="eb-bike-title eb-drop-down-title">
                  Year of manufacture
                </div>
                <div className="model-options-div eb-drop-down-options">
                  {year.map((el, i) => (
                    <div
                      onClick={() => {
                        handleModelYearDropDown(el);
                      }}
                      className="eb-individual-modelYear-drop-down-div eb-common-single-div"
                      key={i}
                    >
                      {el}
                    </div>
                  ))}
                </div>
              </div>
            </GenericModal>
          </div>
        )}

        {/* Bike Loan drop down */}
        {showBikeLoan && (
          <div className="eb-loan-drop-down  eb-common-drop-down-container">
            <GenericModal
              onClose={() => {
                setShowBikeLoan(false);
              }}
              showClose={false}
              botSheet={true}
            >
              <div className="eb-inside-generic-loan-drop-down eb-common-div">
                <div className="eb-bike-title eb-drop-down-title">
                  Vehicle Loan Status
                </div>
                <div className="model-options-div eb-drop-down-options">
                  {loan.map((el, i) => (
                    <div
                      onClick={() => {
                        handleLoanDropDown(el);
                      }}
                      className="eb-individual-modelYear-drop-down-div eb-common-single-div"
                      key={i}
                    >
                      {el}
                    </div>
                  ))}
                </div>
              </div>
            </GenericModal>
          </div>
        )}

        {/* Bike condition drop down */}
        {showBikeCondition && (
          <div className="eb-condition-drop-down  eb-common-drop-down-container">
            <GenericModal
              onClose={() => {
                setShowBikeCondition(false);
              }}
              showClose={false}
              botSheet={true}
            >
              <div className="eb-inside-generic-condition-drop-down eb-common-div">
                <div className="eb-bike-title eb-drop-down-title">
                  Vehicle Condition
                </div>
                <div className="model-options-div eb-drop-down-options">
                  {condtion.map((el, i) => (
                    <div
                      onClick={() => {
                        handleConditionDropDown(el);
                      }}
                      className="eb-individual-modelYear-drop-down-div eb-common-single-div"
                      key={i}
                    >
                      {el}
                    </div>
                  ))}
                </div>
              </div>
            </GenericModal>
          </div>
        )}

        {/* Bike Range drop down */}
        {showBikeRange && (
          <div className="eb-condition-drop-down  eb-common-drop-down-container">
            <GenericModal
              onClose={() => {
                setShowBikeRange(false);
              }}
              showClose={false}
              botSheet={true}
            >
              <div className="eb-inside-generic-condition-drop-down eb-common-div">
                <div className="eb-bike-title eb-drop-down-title">
                  Vehicle Range
                </div>
                <div className="model-options-div eb-drop-down-options">
                  {range.map((el, i) => (
                    <div
                      onClick={() => {
                        handleRangeDropDown(el);
                      }}
                      className="eb-individual-modelYear-drop-down-div eb-common-single-div"
                      key={i}
                    >
                      {(el.from_distance >= 60000 && el.to_distance == 300000) ? `Greater than ${el.from_distance}` : el.from_distance + " - " + el.to_distance}
                    </div>
                  ))}
                </div>
              </div>
            </GenericModal>
          </div>
        )}

        {/* Ownership drop down */}
        {showOwnership && (
          <div className="eb-ownership-drop-down  eb-common-drop-down-container">
            <GenericModal
              onClose={() => {
                setShowOwnership(false);
              }}
              showClose={false}
              botSheet={true}
            >
              <div className="eb-inside-generic-condition-drop-down eb-common-div">
                <div className="eb-bike-title eb-drop-down-title">
                  Vehicle Ownership
                </div>
                <div className="model-options-div eb-drop-down-options">
                  {ownerships.map((el, i) => (
                    <div
                      onClick={() => {
                        handleOwnershipDropDown(el);
                      }}
                      className="eb-individual-ownership-drop-down-div eb-common-single-div"
                      key={i}
                    >
                      {ownershipMap[el]}
                    </div>
                  ))}
                </div>
              </div>
            </GenericModal>
          </div>
        )}

        {/* ec region popup */}
        {showEcRegion && (
          <div className="eb-brand-drop-down eb-common-drop-down-container">
            <GenericModal
              onClose={() => {
                setShowEcRegion(false);
                setSearchedEcRegion("")
              }}
              showClose={false}
              botSheet={true}
            >
              <div className="eb-inside-generic-brand-drop-down eb-common-div">
                <div className="eb-bike-title eb-drop-down-title">
                  Ec Region
                </div>
                <div style={{ marginBottom: '20px' }} className="search-by-exchange-partner">
                  <FloatingInput
                    id="vehicle_brand"
                    name="vehicle_brand"
                    type="text"
                    labelName="Search Ec Region"
                    inputValue={searchedEcRegion}
                    onChange={(val) => { setSearchedEcRegion(val?.target?.value) }}
                    placeholder="Search Ec Region"
                    className={"eb-floatingInput"}
                    maxLength="10"
                  />
                </div>
                <div className="brand-options-div eb-drop-down-options exchange-partner-map-div">
                  {searchedEcRegion.length == 0 ? ecRegions.map((el, i) => (
                    <div
                      onClick={() => {
                        handleEcRegionDropDown(el);
                      }}
                      className="eb-individual-brand-drop-down-div eb-common-single-div"
                      key={i}
                    >
                      {el?.name}
                    </div>
                  )) : ecRegions.filter((a) => a?.name.toLocaleLowerCase().includes(searchedEcRegion.toLocaleLowerCase())).map((el, i) => (
                    <div
                      onClick={() => {
                        handleEcRegionDropDown(el);
                      }}
                      className="eb-individual-brand-drop-down-div eb-common-single-div"
                      key={i}
                    >
                      {el?.name}
                    </div>
                  ))}
                </div>
              </div>
            </GenericModal>
          </div>
        )}

        {/* ec name popup */}
        {showEcName && (
          <div className="eb-brand-drop-down eb-common-drop-down-container">
            <GenericModal
              onClose={() => {
                setShowEcName(false);
                setSearchedEcName("")
              }}
              showClose={false}
              botSheet={true}
            >
              <div className="eb-inside-generic-brand-drop-down eb-common-div">
                <div className="eb-bike-title eb-drop-down-title">
                  Ec Name
                </div>
                <div style={{ marginBottom: '20px' }} className="search-by-exchange-partner">
                  <FloatingInput
                    id="vehicle_brand"
                    name="vehicle_brand"
                    type="text"
                    labelName="Search Ec Name"
                    inputValue={searchedEcName}
                    onChange={(val) => { setSearchedEcName(val?.target?.value) }}
                    placeholder="Search Ec Name"
                    className={"eb-floatingInput"}
                    maxLength="10"
                  />
                </div>
                <div className="brand-options-div eb-drop-down-options exchange-partner-map-div">
                  {searchedEcName.length == 0 ? ecNames.map((el, i) => (
                    <div
                      onClick={() => {
                        handleEcNameDropDown(el);
                      }}
                      className="eb-individual-brand-drop-down-div eb-common-single-div"
                      key={i}
                    >
                      {el?.name}
                    </div>
                  )) : ecNames.filter((a) => a?.name.toLocaleLowerCase().includes(searchedEcName.toLocaleLowerCase())).map((el, i) => (
                    <div
                      onClick={() => {
                        handleEcNameDropDown(el);
                      }}
                      className="eb-individual-brand-drop-down-div eb-common-single-div"
                      key={i}
                    >
                      {el?.name}
                    </div>
                  ))}
                </div>
              </div>
            </GenericModal>
          </div>
        )}

        {/* show verify popup */}
        {showVerifyPopup && (
            <GenericModal
              onClose={() => {
                if (!isLoading) {
                  setShowVerifyPopup(false)
                }
              }}
              showClose={false}
            >
            <div className="verifyPopupWrapper">
              <div className="headerContainer">
                <div>
                    <div style={{ margin: "0" }} className="header-text">
                  Confirm exchange offer
                  </div>
                  <div
                    style={{ margin: "0", marginBottom: "24px" }}
                    className="popup-sub"
                  >
                    {history.location.state?.order_id}
                  </div>
                 </div>
                 <img src={exchangeIcon} alt="" />
              </div>

              <div className="container">
                <div className="list">
                  <p className="label">
                  Bike details
                  </p>
                  <p className="value">
                  {brandName} {modelName} ({modelYear}) ({kilometer?.from_distance + '-' + kilometer?.to_distance}) KM
                  </p>
                </div>
                <div className="list">
                  <p className="label">
                  Exchange value
                  </p>
                  <p className="value">
                  {exchangeValue}
                  </p>
                </div>
                <div className="btnContainer">
                  <div className="greyBtn" onClick={() => !isLoading && setShowVerifyPopup(false)}>
                  Cancel
                  </div>
                  <div className="blackBtn" onClick={() => { handleSubmit(false,true) }}>
                  {!isLoading ? 'Confirm' : 'Uploading...'}
                  </div>
                </div>
              </div>
              </div>
            </GenericModal>
        )}

        {/* Bike Variant drop down */}
        {showVariant &&
              <div className='eb-model-drop-down  eb-common-drop-down-container'>
                  <GenericModal onClose={() => { setShowVariant(false); setSearchedVariant("") }} showClose={false} botSheet={true}>
                      <div className='eb-inside-generic-model-drop-down eb-common-div'>
                          <div className='eb-bike-title eb-drop-down-title'>Variant</div>
                          <div style={{marginBottom:'20px'}} className="search-by-exchange-partner">
                          <FloatingInput
                            id="vehicle_variant"
                            name="vehicle_variant"
                            type="text"
                            labelName="search vehicle variant"
                            inputValue={searchedVariant}
                            onChange={(val) => { setSearchedVariant(val?.target?.value) }}
                            placeholder="Search Vehicle Variant"
                            className={"eb-floatingInput"}
                            maxLength="10"
                          />
                          </div>
                          <div className='model-options-div eb-drop-down-options exchange-partner-map-div'>
                              {searchedVariant.length == 0 ? variants?.map((el, i) => (
                                  <div onClick={() => { handleVariantDropDown(el) }} className='eb-individual-model-drop-down-div eb-common-single-div' key={i}>
                                      {el}
                                  </div>
                              )) : variants?.filter((a) => a.toLocaleLowerCase().includes(searchedVariant.toLocaleLowerCase()))?.map((el, i) => (
                                <div onClick={() => { handleVariantDropDown(el) }} className='eb-individual-model-drop-down-div eb-common-single-div' key={i}>
                                    {el}
                                </div>
                            ))}
                          </div>
                      </div>
                  </GenericModal>
              </div>
          }

          {/* Bike Color drop down */}
            {showColor &&
              <div className='eb-model-drop-down  eb-common-drop-down-container'>
                  <GenericModal onClose={() => { setShowColor(false) }} showClose={false} botSheet={true}>
                      <div className='eb-inside-generic-model-drop-down eb-common-div'>
                          <div className='eb-bike-title eb-drop-down-title'>Color</div>
                          <div className='model-options-div eb-drop-down-options'>
                            <div 
                              onClick={() => { handleColorDropDown("Others") }} 
                              className='eb-individual-model-drop-down-div eb-common-single-div'
                            >
                              Others
                            </div>
                              {colors.map((el, i) => (
                                  <div onClick={() => { handleColorDropDown(el) }} className='eb-individual-model-drop-down-div eb-common-single-div' key={i}>
                                      {colorGroups[el?.color] ? colorGroups[el?.color]?.join("/") : el?.color}
                                  </div>
                              ))}
                          </div>
                      </div>
                  </GenericModal>
              </div>
          }
      {showSplitErrorPopup && (
        <GenericModal onClose={() => setShowSplitErrorPopup(false)} showClose={false}>
          <div className="popupHead">
            <div>{splitPayErrorHeader}</div>
            <img src={warnIcon} alt="exchangeIcon" />
          </div>
          <div className="popup-sub">{splitPayErrorSubtext}</div>
          <div>
            <button
              onClick={() => setShowSplitErrorPopup(false)}
              className="primary-btn"
              style={{width: 'calc(100% - 16px)', margin: '8px', marginTop: '16px'}}
            >
              Got It
            </button>
          </div>
        </GenericModal>
      )}

        <div className="toastWrapper">
          <div style={{ display: showToast }} className="toastContainer">
            {toastMessage}
          </div>
        </div>
        {
          isLoading && (
            <Loader/>
          )
        }
      </div>
    </>
  );
}

export default ScooterExchangeEdit;
